<template>
  <div class="bot-riot-lists-container">
    <div class="bot-riot-lists">
      <div class="title">
        <span>Riot комнаты</span>
        <Button class="ml-1" @click="newBotRiotList()" icon="plus" />
      </div>
      <BotRiotList
        v-for="(botRiotList, index) in riotBotRiotList"
        :class="{ 'mt-1': index != 0 }"
        :key="botRiotList.id ? botRiotList.id : botRiotList.t_id"
        :botRiotList="botRiotList"
      />
      <div class="title">
        <span>Telegram чаты</span>
        <Button class="ml-1" @click="newBotRiotList('telegram')" icon="plus" />
      </div>
      <BotRiotList
        v-for="(botRiotList, index) in telegramBotRiotList"
        :class="{ 'mt-1': index != 0 }"
        :key="botRiotList.id ? botRiotList.id : botRiotList.t_id"
        :botRiotList="botRiotList"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import utilsMessengers from "@/common/utils.messengers.js";

import BotRiotList from "./BotRiotList.vue";
export default {
  props: ["botRiotLists"],
  computed: {
    ...mapState("users", { user: "active" }),
    riotBotRiotList() {
      if (!this.botRiotLists) return [];
      return this.botRiotLists.filter(l => l.messenger_type == utilsMessengers.riot.type);
    },
    telegramBotRiotList() {
      if (!this.botRiotLists) return [];
      return this.botRiotLists.filter(l => l.messenger_type == utilsMessengers.telegram.type);
    }
  },
  components: { BotRiotList },
  data() {
    return {};
  },
  methods: {
    newBotRiotList(messengerType) {
      this.botRiotLists.push({
        t_id: Date.now(),
        riot_room_id: "",
        user_id: null,
        messenger_type: utilsMessengers.toId(messengerType)
      });
    }
  }
};
</script>
<style lang="postcss">
.bot-riot-lists-container {
  .bot-riot-lists {
    .title {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: auto auto 1fr;
      grid-tempate-rows: 2em;
      align-items: center;

      span {
      }
    }
  }
}
</style>
